import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { clearLedger, fetchLedgerAsync } from "../../store/slices/ledgerSlice";
import { toast } from "react-toastify";
import { formatDateTimeUtils } from "../../utils/comman";

const ProfitLoss = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { data, loading } = useSelector((state) => state.ledger || {});

  const [sportType, setSportType] = useState("ALL");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const userId = useMemo(() => {
    const raw = new URLSearchParams(location.search).get("userId");
    return raw ? String(raw).trim() : "";
  }, [location.search]);

  const toApiRange = (fromDateString, toDateString) => {
    if (!fromDateString || !toDateString) return null;
    const from = new Date(fromDateString);
    const to = new Date(toDateString);

    const fromUtc = new Date(
      Date.UTC(
        from.getFullYear(),
        from.getMonth(),
        from.getDate(),
        18,
        30,
        0,
        0,
      ),
    );
    const toUtc = new Date(
      Date.UTC(to.getFullYear(), to.getMonth(), to.getDate(), 18, 29, 59, 999),
    );

    return {
      from_date: fromUtc.toISOString(),
      to_date: toUtc.toISOString(),
    };
  };

  useEffect(() => {
    const today = new Date();
    const sevenDaysAgo = new Date(today);
    sevenDaysAgo.setDate(today.getDate() - 7);

    const formatForInput = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    const defaultStart = formatForInput(sevenDaysAgo);
    const defaultEnd = formatForInput(today);

    setStartDate(defaultStart);
    setEndDate(defaultEnd);

    const range = toApiRange(defaultStart, defaultEnd);
    if (range) {
      dispatch(clearLedger());
      const payload = { ...range, limit: 50, page: 1 };
      if (userId) payload.user_id = userId;
      dispatch(
        fetchLedgerAsync({
          ...payload,
        }),
      );
    }
  }, [dispatch, userId]);

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!startDate || !endDate) {
      toast.error("Please select both start and end dates.");
      return;
    }

    const range = toApiRange(startDate, endDate);
    if (!range) {
      toast.error("Please select a valid date range.");
      return;
    }

    const payload = {
      ...range,
      limit: 50,
      page: 1,
    };

    if (sportType && sportType !== "ALL") {
      payload.event_type_id = sportType;
    }

    dispatch(fetchLedgerAsync(payload));
  };

  const rows = useMemo(() => {
    if (!Array.isArray(data) || !data.length) return [];
    return data.map((item, index) => ({
      ...item,
      index: index + 1,
    }));
  }, [data]);

  const totalPL = useMemo(() => {
    if (!Array.isArray(data) || !data.length) return 0;
    return data.reduce((sum, item) => sum + (item.net_pl || 0), 0);
  }, [data]);

  return (
    <section className="section accounts">
      <div className="row g-0">
        <div className="col-xl-12">
          <h2 className="userscreen-title">
            {" "}
            Profit Loss{" "}
            <span className="total-pl">
              Total P/L : IR{" "}
              <b className={totalPL >= 0 ? "profit" : "loss"}>
                {" "}
                {totalPL.toFixed(2)}
              </b>
            </span>
          </h2>
          <div className="form_search">
            <form
              noValidate
              className="ng-untouched ng-pristine ng-valid"
              onSubmit={handleSubmit}
            >
              <div className="row d-flex align-items-center justify-content-around g-0">
                <div className="col-md-2 col-6">
                  <label className="small">Sports Type :</label>
                  <select
                    className="form-control"
                    value={sportType}
                    onChange={(event) => setSportType(event.target.value)}
                  >
                    <option value="ALL">All Sports </option>
                    <option value="4">Cricket </option>
                    <option value="1">Football </option>
                    <option value="2">Tennis </option>
                    <option value="2378961">Politics </option>
                    <option value="99998">Int Casino </option>
                    <option value="99991">Sports book </option>
                    <option value="7">Horse Racing </option>
                    <option value="4339">Greyhound Racing </option>
                    <option value="99990">Binary </option>
                    <option value="99994">Kabaddi </option>
                    <option value="7522">Basketball </option>
                    <option value="7511">Baseball </option>
                    <option value="20">Table Tennis </option>
                    <option value="998917">Volleyball </option>
                    <option value="7524">Ice Hockey </option>
                    <option value="5">Rugby </option>
                    <option value="26420387">Mixed Martial Arts </option>
                    <option value="3503">Darts </option>
                    <option value="29">Futsal </option>
                  </select>
                </div>
                <div className="col-md-2 col-6">
                  <label className="small">From Date :</label>
                  <input
                    type="date"
                    placeholder="From"
                    className="form-control"
                    value={startDate}
                    onChange={(event) => setStartDate(event.target.value)}
                  />
                </div>
                <div className="col-md-2 col-6">
                  <label className="small">To Date :</label>
                  <input
                    type="date"
                    placeholder="To"
                    className="form-control"
                    value={endDate}
                    onChange={(event) => setEndDate(event.target.value)}
                  />
                </div>
                <div className="col-md-2 col-6 mt-3 pt-1">
                  <button type="submit" className="btn btn-fs">
                    Submit
                  </button>
                </div>
                <div className="col-md-4 text-md-end text-center">
                  <div className="document_button"></div>
                </div>
              </div>
            </form>
          </div>
          <div className="table-responsive">
            <table className="datatable table table-striped table-bordered">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Date</th>
                  <th>Event</th>
                  <th>Comm In</th>
                  <th>Comm Out</th>
                  <th>Amount</th>
                  <th>Total</th>
                  <th>Info</th>
                </tr>
              </thead>
              <tbody>
                {loading && (
                  <tr>
                    <td colSpan="8" className="noData">
                      Loading...
                    </td>
                  </tr>
                )}
                {!loading && rows.length === 0 && (
                  <tr>
                    <td colSpan="8" className="noData">
                      No Data Found
                    </td>
                  </tr>
                )}
                {!loading &&
                  rows.length > 0 &&
                  rows.map((row) => (
                    <tr key={row._id || row.index}>
                      <td>{row.index}</td>
                      <td>
                        {formatDateTimeUtils(
                          row.result_date || row.match_date || "-",
                        )}
                      </td>
                      <td>{row.match_name || row.event_name || "-"}</td>
                      <td>{row.comm_in ?? row.commission_in ?? "-"}</td>
                      <td>{row.comm_out ?? row.commission_out ?? "-"}</td>
                      <td>{row.amount ?? row.net_pl ?? "-"}</td>
                      <td>{row.user_pl ?? row.total ?? "-"}</td>
                      <td>{row.info ?? row.sport_name ?? "-"}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProfitLoss;
